import * as React from 'react'

function IconRoundedRectangle({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={143}
      viewBox="0 0 104 143"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter3_rounded)" fill={color}>
            <path d="M104 16.354v109.532h-.081c-5.2 0-10.087 2.225-13.721 5.945-5.96 6.092-20.816 10.414-38.2 10.414-17.38 0-32.24-4.317-38.2-10.414-3.635-3.715-8.522-5.94-13.722-5.94H0V16.354h.076c5.195 0 10.087-2.225 13.722-5.94C19.758 4.322 34.618 0 51.998 0c17.384 0 32.24 4.317 38.2 10.41 3.634 3.714 8.521 5.944 13.721 5.944H104z" />
            <path
              d="M51.998 132.852c-17.543 0-28.623-4.643-31.486-7.57-3.21-3.284-7.005-5.712-11.118-7.181V24.144c4.113-1.468 7.903-3.897 11.118-7.18 2.863-2.928 13.947-7.57 31.486-7.57 17.538 0 28.623 4.642 31.486 7.57 3.214 3.283 7.009 5.712 11.123 7.18V118.1c-4.114 1.469-7.909 3.897-11.123 7.181-2.863 2.927-13.944 7.57-31.486 7.57z"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter3_rounded"
              x={0}
              y={0}
              width={104}
              height={142.245}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M104 16.354v109.532h-.081c-5.2 0-10.087 2.225-13.721 5.945-5.96 6.092-20.816 10.414-38.2 10.414-17.38 0-32.24-4.317-38.2-10.414-3.635-3.715-8.522-5.94-13.722-5.94H0V16.354h.076c5.195 0 10.087-2.225 13.722-5.94C19.758 4.322 34.618 0 51.998 0c17.384 0 32.24 4.317 38.2 10.41 3.634 3.714 8.521 5.944 13.721 5.944H104z"
            fill={color}
          />
          <path
            d="M51.998 132.852c-17.543 0-28.623-4.643-31.486-7.57-3.21-3.284-7.005-5.712-11.118-7.181V24.144c4.113-1.468 7.903-3.897 11.118-7.18 2.863-2.928 13.948-7.57 31.486-7.57s28.623 4.642 31.486 7.57c3.214 3.283 7.01 5.712 11.123 7.18v93.957c-4.114 1.469-7.909 3.897-11.123 7.181-2.863 2.927-13.943 7.57-31.486 7.57z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRoundedRectangle
